import _kebabCase from 'lodash/kebabCase';
import assert from 'http-assert-plus';
import supportedFonts from '@src/../static/fonts/supportedFonts.json';

export function getFontFamily(font) {
  if (typeof supportedFonts[font] === 'object' && typeof supportedFonts[font].family === 'string') {
    return supportedFonts[font].family;
  } else if (typeof supportedFonts[font] === 'string') {
    return supportedFonts[font];
  } else {
    return font;
  }
}

export function getFontLinks(font) {
  const links = [];

  if (typeof supportedFonts[font] === 'object' && typeof supportedFonts[font].url === 'string') {
    let { url: href } = supportedFonts[font];
    if (href.startsWith('https://fonts.googleapis.com')) {
      links.push({
        vmid: 'font:googlefonts-prefetch',
        href: 'https://fonts.gstatic.com',
        rel: 'preconnect',
      });
    } else if (/^https:\/\/platform([^.]*).reallinks.(io|dev)\/static/.test(href)) {
      // Strip off the hostname since /static is identical between all clients
      href = href.substr(href.indexOf('/static'));
    }

    links.push({
      vmid: `font:${_kebabCase(`${font}`.toLowerCase())}`,
      href,
      rel: 'stylesheet',
    });
  }

  return links;
}

export function getFontList(companyHandle) {
  assert(!companyHandle || typeof companyHandle === 'string', new Error('Expected companyHandle to be a string'));
  return Object.keys(supportedFonts).filter(font => {
    if (supportedFonts[font] && Array.isArray(supportedFonts[font].companyHandles)) {
      return companyHandle && supportedFonts[font].companyHandles.includes(companyHandle);
    }
    return true;
  });
}



// WEBPACK FOOTER //
// ./src/lib/fonts.js